import { render, staticRenderFns } from "./SaveRetentionOptions.vue?vue&type=template&id=dcb2f624&"
import script from "./SaveRetentionOptions.vue?vue&type=script&lang=js&"
export * from "./SaveRetentionOptions.vue?vue&type=script&lang=js&"
import style0 from "./SaveRetentionOptions.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports